/* Presentation only: the same game works inline and in a native modal. */
(() => {
  if(customElements.get('ks-saco-display'))return;
  class CrystalDisplay extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.abort=new AbortController();
      this.dialog=this.querySelector('dialog');this.launcher=this.querySelector('.ks-launcher');
      this.closeButton=this.querySelector('.ks-popup-close');
      this.key='ks-saco-popup:'+this.dataset.campaign;
      const on=(node,event,handler)=>node.addEventListener(event,handler,{signal:this.abort.signal});
      on(this.launcher,'click',()=>this.openPopup());on(this.closeButton,'click',()=>this.closePopup());
      on(this.dialog,'close',()=>this.afterClose());
      on(this,'kg:close',()=>this.closePopup());
      on(this.dialog,'cancel',e=>{e.preventDefault();this.closePopup();});
      on(this.dialog,'click',e=>{
        const r=this.dialog.getBoundingClientRect();
        if(e.target===this.dialog&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))this.closePopup();
      });
      const section=this.closest('.shopify-section');
      if(section){
        on(section,'shopify:section:select',()=>{if(this.dataset.mode==='popup')this.openPopup();});
        on(section,'shopify:section:deselect',()=>this.closePopup());
      }
      on(this.launcher,'animationend',e=>{
        if(e.animationName==='ks-launcher-bounce')this.launcher.classList.remove('ks-launcher-bounce');
      });
      this.gate();
    }
    // Pregunta a Atlas si la campaña está abierta. Cerrada o vencida: el juego no se muestra.
    // En el editor, en modo de prueba o si Atlas no responde, se muestra igual.
    async gate(){
      const game=this.querySelector('ks-saco');
      let campaign='';try{campaign=JSON.parse(this.querySelector('script.ks-config')?.textContent||'{}').campaign||'';}catch{}
      const endpoint=game?.dataset.endpoint||'';
      if(globalThis.Shopify?.designMode||!endpoint||!campaign||game.dataset.demo==='true'){this.configure();return;}
      const inline=this.dataset.mode!=='popup';
      if(inline)this.configure();
      let open=true;
      try{
        const url=new URL(endpoint);url.searchParams.set('status','1');url.searchParams.set('campaign',campaign);
        const controller=new AbortController();const t=setTimeout(()=>controller.abort(),5000);
        const response=await fetch(url,{credentials:'omit',signal:controller.signal});clearTimeout(t);
        const data=await response.json();
        if(response.ok&&data.ok===true&&data.active===false)open=false;
      }catch{}
      if(!this.isConnected)return;
      if(!open){
        clearTimeout(this.timer);if(this.dialog.open)this.dialog.close();this.afterClose();
        this.style.display='none';const section=this.closest('.shopify-section');if(section)section.style.display='none';
        return;
      }
      if(!inline)this.configure();
    }
    configure(){
      clearTimeout(this.timer);
      if(this.dialog.open)this.dialog.close();
      this.afterClose();
      const popup=this.dataset.mode==='popup';
      this.dialog.dataset.modal=String(popup);
      this.closeButton.hidden=!popup;
      this.launcher.hidden=!popup||this.dataset.trigger==='auto'||this.dataset.launcher==='off';
      this.configureLauncherBounce();
      if(!popup){this.dialog.setAttribute('role','presentation');this.dialog.removeAttribute('aria-label');this.dialog.setAttribute('open','');return;}
      this.dialog.removeAttribute('role');this.dialog.setAttribute('aria-label',this.querySelector('ks-saco')?.t?.('popup_label')||'Descubre tu descuento Kinegun');
      if(globalThis.Shopify?.designMode){this.openPopup();return;}
      if(this.dataset.trigger!=='manual'&&this.canAutoOpen()){
        const seconds=Math.max(0,Math.min(60,Number(this.dataset.delay)||0));
        this.timer=setTimeout(()=>{if(this.isConnected&&this.canAutoOpen())this.openPopup();},seconds*1000);
      }
    }
    configureLauncherBounce(){
      clearInterval(this.bounceTimer);
      this.launcher.classList.remove('ks-launcher-bounce');
      if(this.launcher.hidden||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      const seconds=Math.max(5,Math.min(60,Number(this.dataset.launcherBounceInterval)||20));
      this.bounceTimer=setInterval(()=>{
        if(!this.isConnected||this.launcher.hidden||this.dialog.open||document.visibilityState==='hidden')return;
        this.launcher.classList.remove('ks-launcher-bounce');
        void this.launcher.offsetWidth;
        this.launcher.classList.add('ks-launcher-bounce');
      },seconds*1000);
    }
    canAutoOpen(){
      if(this.dataset.frequency==='always')return true;
      if(this.shown)return false;
      try{
        const storage=this.dataset.frequency==='day'?localStorage:sessionStorage;
        const previous=Number(storage.getItem(this.key));
        return !previous||(this.dataset.frequency==='day'&&Date.now()-previous>=86400000);
      }catch{return true;}
    }
    openPopup(){
      if(this.dataset.mode!=='popup'||this.dialog.open)return;
      // Avoid overlapping another native modal (cart, consent, or another campaign).
      if(document.querySelector('dialog:modal'))return;
      clearTimeout(this.timer);this.returnFocus=document.activeElement;
      this.dialog.showModal();document.documentElement.classList.add('ks-popup-open');
      this.closeButton.focus({preventScroll:true});
      this.querySelector('ks-saco')?.resizeCanvas();
      this.shown=true;
      if(!globalThis.Shopify?.designMode&&this.dataset.frequency!=='always'){
        try{(this.dataset.frequency==='day'?localStorage:sessionStorage).setItem(this.key,String(Date.now()));}catch{}
      }
    }
    closePopup(){if(this.dataset.mode==='popup'&&this.dialog.open){this.dialog.close();this.afterClose();}}
    afterClose(){
      if(this.dialog?.open&&this.dataset.mode==='popup')return;
      if(!document.querySelector('ks-saco-display dialog[data-modal="true"][open]'))document.documentElement.classList.remove('ks-popup-open');
      if(this.returnFocus?.isConnected){this.returnFocus.focus({preventScroll:true});this.returnFocus=null;}
    }
    disconnectedCallback(){clearTimeout(this.timer);clearInterval(this.bounceTimer);this.abort?.abort();if(this.dialog?.open)this.dialog.close();this.afterClose();this.ready=false;}
  }
  customElements.define('ks-saco-display',CrystalDisplay);
})();